import { type Atom, useAtomValue } from 'jotai'

// keys省略時は両map合わせた全キーを見る。呼び出し側が対象を絞りたい場合
// (例: ゴミ箱で削除済みのブランドの残存コメントを無視したい)だけkeysを渡す。
// 読み取りしかしないため、書き込みも含む PrimitiveAtom ではなく Atom を受け取る。
export const useIsCommentMapDirty = (
  commentMapAtom: Atom<Partial<Record<string, string>>>,
  savedCommentMapAtom: Atom<Partial<Record<string, string>>>,
  keys?: string[],
): boolean => {
  const commentMap = useAtomValue(commentMapAtom)
  const savedCommentMap = useAtomValue(savedCommentMapAtom)
  const targetKeys = keys ?? Object.keys({ ...commentMap, ...savedCommentMap })

  return targetKeys.some(
    (key) => (commentMap[key] ?? '') !== (savedCommentMap[key] ?? ''),
  )
}
